import * as z from 'zod';

export const BrandSchema = z.object({
  name: z
    .string({
      message: 'Name is required!',
    })
    .min(4, {
      message: 'Name at least 4 charecter!',
    }),
  description: z
    .string({
      message: 'Description is required!',
    })
    .min(5, {
      message: 'Description at least 5 charecter!',
    }),
});
